function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

import { DIRECTIVE_NAMES, DIRECTIVE_TYPES, SUGGEST_TYPES, LINE_SIZE, WEIGHT, MESSAGE_TYPE, CARD_TYPES } from './const';

/**
 * Является ли директивы саджестом
 * @param {String} directive.name
 * @return {Boolean}
 */
export var directiveIsSuggest = function directiveIsSuggest() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref.name;

    return name === DIRECTIVE_NAMES.onSuggest;
};

/**
 * Является ли директивы внешней кнопкой
 * @param {String} directive.name
 * @return {Boolean}
 */
export var directiveIsExternalButton = function directiveIsExternalButton() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref2.name;

    return name === DIRECTIVE_NAMES.onExternalButton;
};

/**
 * Получить список сообщений из директив
 * @param {Array<Directive>} directives
 * @param {Array<String>}
 */
export var getMessageFromDirectives = function getMessageFromDirectives() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return directives.reduce(function (aux, directive) {
        var message = getMessageFromDirective(directive);

        return message ? aux.concat(message) : aux;
    }, []);
};

/**
 * Получить сообщение из директивы
 * @param {Directive} directive
 * @param {Array<String>}
 */
export var getMessageFromDirective = function getMessageFromDirective(directive) {
    if (directive.type !== DIRECTIVE_TYPES.clientAction) {
        return '';
    }

    var name = directive.name;

    var isType = name === DIRECTIVE_NAMES.type;
    var isTypeSilent = name === DIRECTIVE_NAMES.typeSilent;

    if (isType || isTypeSilent) {
        return directive.payload.text;
    }

    return '';
};

/**
 * Получить директиву по типу и имени
 * @param {Array<Directives>} directives
 * @param {String} name
 * @param {String} type
 * @return {Object}
 */
export var findDirectiveByName = function findDirectiveByName() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DIRECTIVE_TYPES.clientAction;
    return directives.find(function (directive) {
        return directive.type === type && directive.name === name;
    });
};

/**
 * Получить содержимое директивы по типу и имени
 * @param {Array<Directives>} directives
 * @param {String} type
 * @param {String} name
 * @return {Object}
 */
export var getDirectivePayload = function getDirectivePayload() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    var directive = findDirectiveByName(directives, name, type);

    if (!directive || !directive.payload) {
        return null;
    }

    return directive.payload;
};

/**
 * Получить payload директивы open_dialog
 * @param {Array<Directive>} directives
 * @param {Array<String>}
 */
export var getOpenDialogDirective = function getOpenDialogDirective() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDirectivePayload(directives, DIRECTIVE_TYPES.clientAction, DIRECTIVE_NAMES.openDialog);
};

/**
 * Получить payload директивы end_dialog_session
 * @param {Array<Directive>} directives
 * @param {Array<String>}
 */
export var getEndDialogDirective = function getEndDialogDirective() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDirectivePayload(directives, DIRECTIVE_TYPES.clientAction, DIRECTIVE_NAMES.endDialogSession);
};
/**
 * Получить payload директивы update_dialog_info
 * @param {Array<Directive>} directives
 * @param {Array<String>}
 */
export var getUpdateDialogDirective = function getUpdateDialogDirective() {
    var directives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return getDirectivePayload(directives, DIRECTIVE_TYPES.clientAction, DIRECTIVE_NAMES.updateDialogInfo);
};

/**
 * Является ли саджест отзывом
 * @param  {Object} suggestItem
 * @return {Boolean}
 */
export var isFeedBack = function isFeedBack(suggest) {
    if (!suggest) {
        return false;
    }

    var suggestType = suggest.suggestType;


    return suggestType === SUGGEST_TYPES.feedbackPositive || suggestType === SUGGEST_TYPES.feedbackNegative;
};

/**
 * Сумировать веса подблоков
 * @param {Array}
 * @return {Number}
 */
export var sumWeight = function sumWeight(items) {
    return items.reduce(function (aux, item) {
        return aux + item.weight;
    }, 0);
};

/**
 * Получить максимальный вес подблоков
 * @param {Array}
 * @return {Number}
 */
export var getMaxWeight = function getMaxWeight(items) {
    return Math.max.apply(Math, _toConsumableArray(items.map(function (item) {
        return item.weight;
    })));
};

/**
 * Вес текста
 * @param {String} text
 * @param {Number} maxLines
 */
export var getTextWeight = function getTextWeight() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var maxLines = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
    return Math.round(Math.min(text.length / LINE_SIZE, maxLines)) * WEIGHT.textLine;
};

/**
 * Вес параграфов текста
 * @param {<Array<Array<String>>} paragraphs
 * @return Number
 */
export var getParagraphsWeight = function getParagraphsWeight(paragraphs) {
    return paragraphs.reduce(function (aux, paragraph) {
        return aux + paragraph.reduce(function (bux, line) {
            return bux + getTextWeight(line);
        }, 0);
    }, 0);
};

/**
 * Получение текста из сообщения
 * @param {Message} message
 * @param {String} defaultText
 * @return {String}
 */
export var getTextFromMessage = function getTextFromMessage(message) {
    var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!message) {
        return '';
    }

    switch (message.type) {
        case MESSAGE_TYPE.text:
            return message.text;
        case MESSAGE_TYPE.rich:
            return getTextFromRichMessage(message, defaultText);
        default:
            return defaultText;
    }
};

/**
 * Получение текста из сообщения типа @see MESSAGE_TYPE.rich
 * @param {Message} message
 * @param {String} defaultText
 * @return {String}
 */
var getTextFromRichMessage = function getTextFromRichMessage(message, defaultText) {
    var textCard = message.cards.find(function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            type = _ref3.type;

        return type === CARD_TYPES.text || type === CARD_TYPES.textWithButton;
    });

    if (!textCard || !textCard.text) {
        return defaultText;
    }

    var text = textCard.text;


    if (typeof text === 'string') {
        return text;
    }

    if (Array.isArray(text)) {
        return textCard.text.map(function (subtext) {
            if (Array.isArray(subtext)) {
                return subtext.join(' ');
            }

            return subtext;
        }).join(' ');
    }

    return defaultText;
};